(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ice-freaks-community-board"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-idea-reply]').forEach(function(button){
  button.addEventListener('click',function(){
    var board=button.closest('.ice-board');var compose=board.querySelector('details');var field=board.querySelector('textarea');
    if(!compose||!field)return;
    compose.open=true;
    if(!field.value.trim())field.value='@'+button.dataset.ideaReply+' — ';
    field.focus();
  });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ice-freaks-mask-lab"] && !Shopify.designMode) return;
  try {
    function bindIceMaskIdeas(){
  document.querySelectorAll('#IceMaskIdeas').forEach(function(form){
    if(form.dataset.bound)return;
    form.dataset.bound='true';
    form.querySelectorAll('input[type="radio"]').forEach(function(choice){
      choice.addEventListener('click',function(){var details=form.querySelector('details');if(details)details.open=true;});
      choice.addEventListener('change',function(){var details=form.querySelector('details');if(details)details.open=true;});
    });
  });
}
bindIceMaskIdeas();
document.addEventListener('shopify:section:load',bindIceMaskIdeas);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ice-freaks-showcase"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-if-showcase]').forEach(video=>{
if(video.dataset.ready)return;video.dataset.ready='true';
let loaded=false;const reduced=matchMedia('(prefers-reduced-motion: reduce)').matches;
const observer=new IntersectionObserver(entries=>{entries.forEach(entry=>{
if(entry.isIntersecting){if(!loaded){video.querySelectorAll('source').forEach(s=>s.src=s.dataset.src);video.load();loaded=true}if(!reduced)video.play().catch(()=>{})}
else video.pause();
})},{threshold:0.1});observer.observe(video);
});
  } catch(e) { console.error(e); }
})();

})();
